// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { Auth } from 'aws-amplify';
import { API_ENDPOINT } from '../configuration';
import axios, { AxiosRequestConfig } from 'axios';
import { camelCase, snakeCase } from 'change-case';

axios.interceptors.response.use((response) => {
  try {
    response.data = response.data && response.data === 'string' ? JSON.parse(response.data) : response.data;
    return response
  } catch (e) {
    console.log(e)
    return response
  }
}, function (error) {
  if (typeof error.response?.data === 'object') {
    error.response.data = JSON.stringify(error.response.data);
  }
  return Promise.reject(error);
});

async function getAuthHeader() {
  const cognitoKey = localStorage.getItem('CognitoKey');
  let idToken = localStorage.getItem(`${cognitoKey}.idToken`)
  const userPoolUser = await Auth.currentUserPoolUser().catch((error) => {
    console.log('Token expired or No login', { error });
    window.location.pathname = '/login';
  });
  idToken = userPoolUser
    ? userPoolUser.signInUserSession.idToken.jwtToken : idToken ? idToken : '';
  return { headers: { Authorization: idToken } };
}

async function getAuthUploadHeader() {
  const cognitoKey = localStorage.getItem('CognitoKey');
  let idToken = localStorage.getItem(`${cognitoKey}.idToken`)
  if (!idToken) {
    const userPoolUser = await Auth.currentUserPoolUser().catch((error) => {
      console.log('Token expired or No login', { error });
      window.location.pathname = '/login';
    });
    idToken = userPoolUser
      ? userPoolUser.signInUserSession.idToken.jwtToken
      : '';
  }
  return { headers: { Authorization: idToken } };
}

export async function get(path: string, config?: AxiosRequestConfig) {
  return axios.get(`${API_ENDPOINT}${path}`, {
    responseType: 'json',
    ...config
  });
}

export async function post(
  path: string,
  body?: object,
  config?: AxiosRequestConfig
) {
  return axios.post(`${API_ENDPOINT}${path}`, body, {
    responseType: 'json',
    ...config
  });
}

export async function put(
  path: string,
  body?: object,
  config?: AxiosRequestConfig
) {
  return axios.put(`${API_ENDPOINT}${path}`, body, {
    responseType: 'json',
    ...config
  });
}

export async function _delete(path: string, config?: AxiosRequestConfig) {
  return axios.delete(`${API_ENDPOINT}${path}`, {
    responseType: 'json',
    ...config
  });
}

export async function authGet(path: string, config?: AxiosRequestConfig) {
  return get(path, {
    ...(await getAuthHeader()),
    ...config
  });
}

export async function authPost(
  path: string,
  body?: object,
  config?: AxiosRequestConfig
) {
  return post(path, body, {
    ...(await getAuthHeader()),
    ...config
  });
}

export async function authPut(
  path: string,
  body?: object,
  config?: AxiosRequestConfig
) {
  return put(path, body, {
    ...(await getAuthHeader()),
    ...config
  });
}

export async function authDelete(
  path: string,
  body?: object,
  config?: AxiosRequestConfig
) {
  return _delete(path, {
    ...(await getAuthHeader()),
    ...config
  });
}

function parseNaming(data: any, func: Function): any {
  if (Array.isArray(data)) {
    return data.map(v => parseNaming(v, func))
  } else if (data !== null && typeof data === 'object') {
    return Object.keys(data)
      .map(key => {
        const value = data[key];
        const newKey = func(key);

        return { [newKey]: parseNaming(value, func) }
      })
      .reduce((newObj, obj) => ({ ...newObj, ...obj }), {});
  }
  return data;
}

export function parseCamelCase(data: any): any {
  try {
    return parseNaming(JSON.parse(data), camelCase);
  } catch (e) {
    return parseNaming(data, camelCase);
  }
}

export function parseSnakeCase(data: any): any {
  return parseNaming(data, snakeCase);
}

export async function authUploadPost(
  path: string,
  body?: any,
  config?: AxiosRequestConfig
) {
  const formData = new FormData();
  formData.append('exam_record_id', body.examRecordId);
  formData.append('exam_id', body.examId);
  const fileKey = Object.keys(body.fileList);
  fileKey.map((item: string) => {
    formData.append(item, body.fileList[item]);
  })

  return post(path, formData, {
    ...(await getAuthUploadHeader()),
    ...config
  });
}
